import { render, staticRenderFns } from "./inputNumberComma.vue?vue&type=template&id=3a13c66b&"
import script from "./inputNumberComma.vue?vue&type=script&lang=js&"
export * from "./inputNumberComma.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports